import { Sentry } from "@/services/sentry"
import { isShareCancellation } from "@/services/shareCancellation"
import { Share } from "react-native"

export { isShareCancellation } from "@/services/shareCancellation"

export async function sharePassportLink(content: Parameters<typeof Share.share>[0]) {
  try {
    await Share.share(content)
    return true
  } catch (error) {
    if (isShareCancellation(error)) return false
    Sentry.captureException(error, { tags: { action: "share_passport", area: "passport_share" } })
    throw error
  }
}
